module.exports = __webpack_public_path__ + "media/Video 14.af11d26b.mp4";